<template>
    <section :id="id" class="s-light-wrapper-slice" :class="basicClassName">
        <div v-if="backgroundImage" class="bg-wrapper">
            <a-picture :background="backgroundImage" :fit="backgroundFit" :alt="backgroundImage.alt || title || slices[0]?.data?.title" />
        </div>
        <component
            :is="getComponent(slice.name)"
            v-for="(slice, index) in slices"
            v-bind="slice.data"
            :key="index"
            class="s-light-wrapper-slice__item"
        />
    </section>
</template>

<script>
import APicture from '@core/components/picture/picture.vue';
import validateFit from '@core/components/picture/validateFit.js';
import contentMixin from '@core/mixins/content.js';
import styleMixin from '@core/mixins/style.js';
import { registerSlices } from '@utils/dynamic-slices-resolver';

export default {
    name: 'SLightWrapperSlice',

    components: {
        APicture,
    },

    mixins: [contentMixin, styleMixin],

    props: {
        backgroundImage: {
            type: Object,
            default: null,
        },
        backgroundFit: {
            type: [String, Object],
            required: false,
            default: 'cover',
            validator: validateFit,
        },
        slices: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            componentsRegistry: {},
        };
    },

    created() {
        /*
            This code is required here, because we had occurances of incorrect JSON structure passed via admin panel
            The example was when s-compete-page passed to s-tabs via awardsTabs object instead of slices array
            Our dynamic resolver requires the slice to be passing "slices" array and having { data, name } inside
            Not "awardsTabs": { "slices": [{ data, name }] }
            Other example was s-documentation trough side-menu, so we should remove this code only if we resolve all such cases.
        */

        registerSlices({
            pageBody: this.slices || [],
            componentRegistrar: (name, component) => {
                this.componentsRegistry[name] = component;
            },
        });
    },

    methods: {
        getComponent(name) {
            return this.componentsRegistry[name] || null;
        },
    },
};
</script>

<style lang="pcss" scoped>
section {
    position: relative;
    .bg-wrapper {
        inset: 0;
        position: absolute;
        width: 100%;
        .a-picture,
        :deep(.a-picture__img) {
            height: 100%;
            width: 100%;
        }
    }
}
</style>
